import React from 'react';
import { Progress } from '@nackle/paper';
import { LocaleString, getString } from '@nackle/intl-tools';

export default function BudgetMeter ( props ) {
    const { percent, current, headerText, additionalInfo } = props;
    return (
        <div className='budget-meter-container'>
            { headerText &&
                <div className='header-text'><LocaleString code="recognition.budget.awarded" replaceOptions={ { points: headerText, mediaLabel: getString( 'mediaLabel' ) } } /></div> }
            <Progress percent={ percent } status="active" showInfo={ false } />
            <div className='footer-container'>
                <div className="primary-footer-text"><LocaleString code="recognition.budget.remaining" replaceOptions={ { points: current, mediaLabel: getString( 'mediaLabel' ) } } /> </div>
            { additionalInfo && 
                <div className='secondary-footer-text'>{ additionalInfo }</div>
            }
            </div>
        </div>
    );
}